import React, { Component} from 'react';
import './UserBadge.css';
import * as scriptUtils from './utils/scriptUtils';

class UserBadge extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className={
          this.props.badgeType === "micropayment"
            ?
          "userBadgeDonation"
            :
          "userBadgeRepeat"
        }
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
      >
      </div>
    );
  }
}

export default UserBadge;
